import { type BidHistoryPage } from '@tempmee/awards';
import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { AWARDS_API_PREFIX } from './awardsApiBase';

/**
 * Fetch a page of the member-facing BID history from `GET /cycles`
 * (awards-service `membercycles`). This is also the cycle-discovery read (the
 * active cycle is the one accepting applications/feedback). pageSize is
 * server-fixed at 15 — only `?page=` is sent. The response is the
 * `@tempmee/awards` `BidHistoryPage` envelope verbatim: `toolkitEligible`
 * ("ever a winner") is page-level, computed by the server across all pages —
 * never per row.
 */
export const getBidHistory = async (params: { page: number }): Promise<BidHistoryPage> => {
  const headers = await getAuthHeaders();
  // The server owns the announced-cycle rule (GOTU-5630): a cycle whose
  // `applicationOpenDate` is still in the future is never listed or counted
  // here, so there is deliberately NO client-side pending-cycle filter — don't add one.
  const response = await tempMeeApi.get<BidHistoryPage>(`${AWARDS_API_PREFIX}/cycles`, {
    headers,
    params,
  });
  return response.data;
};
